var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 9C1.3125 11.1746 3.07538 12.9375 5.25 12.9375C6.51821 12.9375 7.6464 12.3379 8.36655 11.4068C8.52578 11.2009 8.7633 11.0625 9.02362 11.0625H10.2849C10.4254 11.0625 10.5632 11.023 10.6824 10.9485L11.6025 10.3734C11.8457 10.2214 12.1543 10.2214 12.3975 10.3734L13.3176 10.9485C13.4368 11.023 13.5746 11.0625 13.7151 11.0625H15.0196C15.2446 11.0625 15.4576 10.9615 15.6001 10.7874L16.6739 9.4749C16.9 9.19867 16.9 8.80133 16.6739 8.5251L15.6001 7.21257C15.4576 7.03847 15.2446 6.9375 15.0196 6.9375H9.02362C8.7633 6.9375 8.52578 6.79912 8.36655 6.59321C7.6464 5.66206 6.51821 5.0625 5.25 5.0625C3.07538 5.0625 1.3125 6.82538 1.3125 9Z",
    stroke: "#FF7926",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 9C5.8125 9.31065 5.56066 9.5625 5.25 9.5625C4.93934 9.5625 4.6875 9.31065 4.6875 9C4.6875 8.68935 4.93934 8.4375 5.25 8.4375C5.56066 8.4375 5.8125 8.68935 5.8125 9Z",
    stroke: "#FF7926",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.a52e2a1f6d33bed1bdaffdc91b9df9d0.svg";
export { ForwardRef as ReactComponent };